/**
 * Loot-tier particle color palettes — single source of truth.
 * T1 common = green, T2 uncommon = teal/blue, T3 epic = purple/pink,
 * T4 legendary = orange/gold. Each tier's palette includes white for sparkle.
 *
 * Used by the overlay particle canvas and the landing page tier demo.
 */
const TIER_COLORS = {
  1: ['#86efac', '#22c55e', '#4ade80', '#ffffff'],
  2: ['#5eead4', '#2dd4bf', '#3b82f6', '#60a5fa', '#ffffff'],
  3: ['#c084fc', '#a855f7', '#ec4899', '#f0abfc', '#ffffff'],
  4: ['#fde047', '#fbbf24', '#f97316', '#fed7aa', '#ffffff'],
};

module.exports = { TIER_COLORS };
